"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/* eslint-disable object-curly-newline, no-param-reassign */
var EventDispatcher = require('../utils/event-dispatcher');

var helpers = require('../utils/helpers'); // Create URL from supplied parameters


function createRecommendationsUrl(podId, parameters, options) {
  var apiKey = options.apiKey,
      version = options.version,
      serviceUrl = options.serviceUrl,
      sessionId = options.sessionId,
      userId = options.userId,
      clientId = options.clientId,
      segments = options.segments;
  var queryParams = {
    c: version
  };
  queryParams.key = apiKey;
  queryParams.i = clientId;
  queryParams.s = sessionId; // Validate pod identifier is provided

  if (!podId || typeof podId !== 'string') {
    throw new Error('podId is a required parameter of type string');
  } // Pull user segments from options


  if (segments && segments.length) {
    queryParams.us = segments;
  } // Pull user id from options and ensure string


  if (userId) {
    queryParams.ui = String(userId);
  }

  if (parameters) {
    var numResults = parameters.numResults,
        itemIds = parameters.itemIds,
        section = parameters.section,
        term = parameters.term,
        filters = parameters.filters,
        variationsMap = parameters.variationsMap; // Pull num results number from parameters

    if (!helpers.isNil(numResults)) {
      queryParams.num_results = numResults;
    } // Pull item ids from parameters


    if (itemIds) {
      queryParams.item_id = itemIds;
    } // Pull section from parameters


    if (section) {
      queryParams.section = section;
    } // Pull term from parameters


    if (term) {
      queryParams.term = term;
    } // Pull filters from parameters


    if (filters) {
      queryParams.filters = filters;
    } // Pull variations map from parameters


    if (variationsMap) {
      queryParams.variations_map = JSON.stringify(variationsMap);
    }
  }

  queryParams = helpers.cleanParams(queryParams);
  var queryString = helpers.stringify(queryParams);
  return "".concat(serviceUrl, "/recommendations/v1/pods/").concat(helpers.encodeURIComponentRFC3986(helpers.trimNonBreakingSpaces(podId)), "?").concat(queryString);
}
/**
 * Interface to recommendations related API calls
 *
 * @module recommendations
 * @inner
 * @returns {object}
 */


var Recommendations = /*#__PURE__*/function () {
  function Recommendations(options) {
    (0, _classCallCheck2["default"])(this, Recommendations);
    this.options = options || {};
    this.eventDispatcher = new EventDispatcher(options.eventDispatcher);
  }
  /**
   * Get recommendations for supplied pod identifier
   *
   * @function getRecommendations
   * @description Retrieve recommendation results from Constructor.io API
   * @param {string} podId - Pod identifier
   * @param {object} [parameters] - Additional parameters to refine results
   * @param {string|array} [parameters.itemIds] - Item ID(s) to retrieve recommendations for (strategy specific)
   * @param {number} [parameters.numResults] - The number of results to return
   * @param {string} [parameters.section] - The section to return results from
   * @param {string} [parameters.term] - The term to use to refine results (strategy specific)
   * @param {object} [parameters.filters] - Key / value mapping of filters used to refine results
   * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.io/rest_api/variations_mapping for details
   * @param {object} [networkParameters] - Parameters relevant to the network request
   * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
   * @returns {Promise}
   * @see https://docs.constructor.io/rest_api/recommendations
   * @example
   * constructorio.recommendations.getRecommendations('t-shirt-best-sellers', {
   *     numResults: 5,
   *     filters: {
   *         size: 'medium'
   *     },
   * });
   */


  (0, _createClass2["default"])(Recommendations, [{
    key: "getRecommendations",
    value: function getRecommendations(podId, parameters) {
      var _this = this;

      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var requestUrl;
      var fetch = this.options.fetch;
      var signal;

      if (typeof AbortController === 'function') {
        var controller = new AbortController();
        signal = controller && controller.signal; // Handle network timeout if specified

        helpers.applyNetworkTimeout(this.options, networkParameters, controller);
      }

      try {
        requestUrl = createRecommendationsUrl(podId, parameters, this.options);
      } catch (e) {
        return Promise.reject(e);
      }

      return fetch(requestUrl, {
        signal: signal
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return helpers.throwHttpErrorFromResponse(new Error(), response);
      }).then(function (json) {
        if (json.response && json.response.results) {
          if (json.result_id) {
            // Append `result_id` to each result item
            json.response.results.forEach(function (result) {
              // eslint-disable-next-line no-param-reassign
              result.result_id = json.result_id;
            });
          }

          _this.eventDispatcher.queue('recommendations.getRecommendations.completed', json);

          return json;
        }

        throw new Error('getRecommendations response data is malformed');
      });
    }
  }]);
  return Recommendations;
}();

module.exports = Recommendations;